<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="客户样本">
      <router-link to="/customer-sample-new" slot="before-left"><el-button type="primary">新建客户样本</el-button></router-link>
    </pt-page-title>
    <!-- 筛选 -->
    <!-- <pt-page-factor-filter :labels="filterLabels" v-model="filterForm">
      <el-button type="primary" @click="handleFilter">筛选</el-button>
    </pt-page-factor-filter> -->
    <!-- 表格 -->
    <pt-customer-sample-table ref="table" :tableLabels="tableLabels">
      <template slot-scope="scope">
        <i class="iconfont icon-xiangqing pointer" @click="goDetail(scope.row.id, scope.row)"></i>
        <i class="iconfont icon-bianji pointer" @click="goEdit(scope.row.id,scope.row)"></i>
        <i class="iconfont icon-shanchu pointer" @click="goDelete(scope.row.id,scope.row)"></i>
      </template>
    </pt-customer-sample-table>
  </div>
</template>

<script>
// 组件class前缀
import ptCustomerSampleTable from './pt-customer-sample-table/withData'
import { filterFactor, tableLabels } from './customer-sample-options.js'
const prefixCls = 'pt-customer-sample-list'

export default {
  name: 'pt-customer-sample-list',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableLabels () {
      return tableLabels
    }
  },
  components: {
    ptCustomerSampleTable
  },
  data () {
    return {
      filterLabels: filterFactor,
      filterForm: {},
      currentCategoryFilter: '',
      loading: false
    }
  },
  methods: {
    handleFilter () {
      this.currentCategoryFilter = this.filterForm.category
      // if (this.filterForm.orderActions === '') {
      //   this.filterForm.orderActions = null
      // }
      // this.filterForm.status = this.currentStatusFilter.split(',')
      // this.filterForm.pageable = { page: 0, size: 10 }
      // this.$refs.table.reload(this.filterForm)
    },
    search (key) {
      // if (this.filterForm.orderActions === '') {
      //   this.filterForm.orderActions = null
      // }
      this.filterForm.chineseName = key
      this.filterForm.pageable = { page: 0 }
      this.$refs.table.reload(this.filterForm)
    },
    goDetail (id, data) {
      // 跳转详情页面时直接将当前数据通过'value'传递，避免再次加载数据的请求。
      this.$router.push({ name: 'detection-detail', params: { id: id, value: data } })
    },
    goEdit (id, data) {
      // 跳转详情页面时直接将当前数据通过'value'传递，避免再次加载数据的请求。
      this.$router.push({ name: 'detection-update', params: { id: id, category: data.category } })
    },
    goDelete (id, data) {
      this.$confirm('是否要删除检测项“' + data.chineseName + '”?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deleteDetection', id).then(res => {
          this.reload()
          this.$message.success('成功删除了检测项' + data.chineseName + '!')
        }).catch(err => {
          this.loading = false
          console.error(err)
          this.$message.error('删除失败!')
        })
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
